import type { Query } from '@ab-core/graphql/dist';
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { GET_CART_BY_ID } from './gql/getCartById';

type QueryDataType = Pick<Query, 'getCart'>;
type OutgoingDataType = QueryDataType['getCart'];

const onError = getErrorLoggerFunction('getCart');

export const useGetCartById = (cartId: string) => {
    const [outgoingData, setOutgoingData] = useState<OutgoingDataType>(undefined);

    const { data, loading, refetch, error } = useQuery<QueryDataType>(GET_CART_BY_ID, {
        variables: { cartId },
        onError
    });

    useEffect(() => {
        if (data) {
            setOutgoingData(data.getCart);
        }
    }, [data]);

    return {
        cart: outgoingData,
        error: !!error,
        success: !!data,
        loading,
        refetch
    };
};
